<template>
  <div>
    <translation :key="`${monster.id}name`" :value="monster.name" :loading="loading" :id="monster.id" @save="save"></translation>
    <translation :key="`${monster.id}description`" :value="monster.description" :loading="loading" :id="monster.id" @save="save"></translation>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import translation from '@/components/settings/translations/translations'

export default {
  props: ['id'],
  components: { translation },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('monsters', {
      getById: 'getById'
    }),
    monster () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('monsters', ['updateMonster']),

    save (id) {
      this.loading = true

      if (!this.monster.name.fr) {
        delete this.monster.name.fr
      }
      if (!this.monster.name.en) {
        delete this.monster.name.en
      }

      if (!this.monster.description.fr) {
        delete this.monster.description.fr
      }
      if (!this.monster.description.en) {
        delete this.monster.description.en
      }

      this.updateMonster({monster: {id: this.monster.id, name: this.monster.name, description: this.monster.description}})
        .then(() => {
          this.loading = 'success'
          this.$notify({title: 'Success', message: this.$root.$t('notifications.translations.edited'), type: 'success'})
        }).catch(() => {
          this.loading = 'failed'
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_monster.vue